/**
 * Meeting Services Module
 * Exports all meeting management services and factory functions
 */
// Service exports (one per controller)
export * from './MeetingService';
export * from './MeetingStatusService';
export * from './MeetingTypeService';
export * from './MeetingVenueService';
export * from './MeetingAttendeeService';
export * from './MeetingAttendanceStatusService';
export * from './MeetingSetupService';
export * from './MeetingRequestService';
export * from './MeetingCommentService';
export * from './MeetingFileService';
export * from './SetupInMeetingService';
export * from './RequestInMeetingService';
export * from './LocationVenueRequestService';
export * from './LocationVenueSetupService';
export * from './MeetingSettingsService';
export * from './VenueBookingService';
export * from './VenueAvailabilityService';
export * from './VenueBlackoutService';
export * from './VenueSetupLayoutService';
export * from './MeetingRecurrenceService';
export * from './MeetingAgendaItemService';
export * from './MeetingMinutesService';
export * from './MeetingActionItemService';
export * from './VenueBookingStatusService';
export * from './MeetingActionItemStatusService';
export * from './SeatingStyleService';
// Service imports for factory
import { MeetingService } from './MeetingService';
import { MeetingStatusService } from './MeetingStatusService';
import { MeetingTypeService } from './MeetingTypeService';
import { MeetingVenueService } from './MeetingVenueService';
import { MeetingAttendeeService } from './MeetingAttendeeService';
import { MeetingAttendanceStatusService } from './MeetingAttendanceStatusService';
import { MeetingSetupService } from './MeetingSetupService';
import { MeetingRequestService } from './MeetingRequestService';
import { MeetingCommentService } from './MeetingCommentService';
import { MeetingFileService } from './MeetingFileService';
import { SetupInMeetingService } from './SetupInMeetingService';
import { RequestInMeetingService } from './RequestInMeetingService';
import { LocationVenueRequestService } from './LocationVenueRequestService';
import { LocationVenueSetupService } from './LocationVenueSetupService';
import { MeetingSettingsService } from './MeetingSettingsService';
import { VenueBookingService } from './VenueBookingService';
import { VenueAvailabilityService } from './VenueAvailabilityService';
import { VenueBlackoutService } from './VenueBlackoutService';
import { VenueSetupLayoutService } from './VenueSetupLayoutService';
import { MeetingRecurrenceService } from './MeetingRecurrenceService';
import { MeetingAgendaItemService } from './MeetingAgendaItemService';
import { MeetingMinutesService } from './MeetingMinutesService';
import { MeetingActionItemService } from './MeetingActionItemService';
import { VenueBookingStatusService } from './VenueBookingStatusService';
import { MeetingActionItemStatusService } from './MeetingActionItemStatusService';
import { SeatingStyleService } from './SeatingStyleService';
/**
 * Create all meeting services with shared configuration
 * @param http - HTTP client instance
 * @param config - Service configuration (servicePath, endpoints)
 * @returns Object containing all meeting service instances
 */
export function createMeetingServices(http, config) {
    return {
        meeting: new MeetingService(http, config),
        meetingStatus: new MeetingStatusService(http, config),
        meetingType: new MeetingTypeService(http, config),
        meetingVenue: new MeetingVenueService(http, config),
        meetingAttendee: new MeetingAttendeeService(http, config),
        meetingAttendanceStatus: new MeetingAttendanceStatusService(http, config),
        meetingSetup: new MeetingSetupService(http, config),
        meetingRequest: new MeetingRequestService(http, config),
        meetingComment: new MeetingCommentService(http, config),
        meetingFile: new MeetingFileService(http, config),
        setupInMeeting: new SetupInMeetingService(http, config),
        requestInMeeting: new RequestInMeetingService(http, config),
        locationVenueRequest: new LocationVenueRequestService(http, config),
        locationVenueSetup: new LocationVenueSetupService(http, config),
        meetingSettings: new MeetingSettingsService(http, config),
        venueBooking: new VenueBookingService(http, config),
        venueAvailability: new VenueAvailabilityService(http, config),
        venueBlackout: new VenueBlackoutService(http, config),
        venueSetupLayout: new VenueSetupLayoutService(http, config),
        meetingRecurrence: new MeetingRecurrenceService(http, config),
        meetingAgendaItem: new MeetingAgendaItemService(http, config),
        meetingMinutes: new MeetingMinutesService(http, config),
        meetingActionItem: new MeetingActionItemService(http, config),
        venueBookingStatus: new VenueBookingStatusService(http, config),
        meetingActionItemStatus: new MeetingActionItemStatusService(http, config),
        seatingStyle: new SeatingStyleService(http, config),
    };
}
//# sourceMappingURL=index.js.map